import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Star, BadgeCheck, ImageOff } from 'lucide-react';
import { base44 } from '@/api/base44Client';

export default function ShowcaseReviews({ rig }) {
  const { data: reviews = [], isLoading } = useQuery({
    queryKey: ['showcase-reviews', rig.id],
    queryFn: () => base44.entities.ShowcaseReview.filter({ rig_id: rig.id }, 'sort_order', 50),
  });

  return (
    <section className="py-20 px-6 lg:px-10 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <p className="text-primary text-xs font-bold tracking-widest mb-3">CUSTOMER REVIEWS</p>
        <h2 className="text-white font-black text-3xl md:text-4xl uppercase mb-10">From The Drivers</h2>

        {isLoading ? (
          <div className="text-white/30 text-sm">Loading reviews…</div>
        ) : reviews.length === 0 ? (
          <p className="text-white/30 text-sm">No reviews yet. Be the first to share your experience.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {reviews.map((rev) => (
              <div key={rev.id} className="bg-[#111115] border border-white/5 p-6 flex flex-col">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <Star
                        key={n}
                        className={`w-3.5 h-3.5 ${n <= (rev.rating || 0) ? 'text-primary fill-primary' : 'text-white/15'}`}
                      />
                    ))}
                  </div>
                  {rev.verified && (
                    <span className="inline-flex items-center gap-1 text-primary text-[10px] font-bold tracking-widest">
                      <BadgeCheck className="w-3.5 h-3.5" /> VERIFIED BOOKING
                    </span>
                  )}
                </div>

                <p className="text-white/70 text-sm leading-relaxed flex-1 mb-4">"{rev.comment}"</p>

                {rev.image_url && (
                  <div className="mb-4 aspect-video bg-[#0d0d0f] overflow-hidden">
                    <img src={rev.image_url} alt="" className="w-full h-full object-cover" />
                  </div>
                )}

                <div className="flex items-center gap-2 pt-3 border-t border-white/5">
                  <div className="w-8 h-8 bg-primary/15 border border-primary/30 flex items-center justify-center text-primary font-bold text-xs">
                    {(rev.author_name || '?').charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <p className="text-white text-xs font-bold">{rev.author_name}</p>
                    {rev.author_location && <p className="text-white/30 text-[10px]">{rev.author_location}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}